import React, { Component } from 'react';

import { Avatar } from 'antd';

import './avatar-menu.css';

class AvatarMenu extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            open: false
        };
    }
    render() {
        const { open } = this.state;
        const { children } = this.props;

        return (
            <section className={`avatar-menu ${open ? 'open': ''}`}>
                <span onClick={ ()=> this.setState({ open: !open})}>
                    <Avatar className='avatar-icon' icon="user" />
                </span>
                <div className='menu'>
                    { children }
                </div>
            </section>
        );
    }
}

export default AvatarMenu;


// WEBPACK FOOTER //
// ./src/App/components/avatar-menu/avatar-menu.js